
export enum RegistrationLinkQuestionTypeModel {
  SingleChoice = 1,
  MultipleChoice = 2,
  Text = 3,
  YesNo = 4
}
